import {
    createSlice,
    PayloadAction,
  } from "@reduxjs/toolkit";
  
  // Initial state of the dis like slice
  export const initialState: {
    healthProfile : boolean;
    pharmacyCategories: {
      mainCategories: number;
      subCategories: number;
      childCategories: number;
    };
  } = {
    healthProfile: false,
    pharmacyCategories: {
      mainCategories: 0,
      subCategories: 0,
      childCategories: 0,
    },
  };
  
  // Create the dis like slice
  export const realTimeState = createSlice({
    name: "REAL_TIME_STATE_SLICE",
    initialState,
    reducers: {
      updateHealthProfile: (state, action: PayloadAction<boolean>) => {
        state.healthProfile = action.payload;
      },
      updatePharmacyCategories: (state, action: PayloadAction<{ mainCategories: number; subCategories: number; childCategories: number; }>) => {
        state.pharmacyCategories = action.payload;
      },
    },
  });
    export const { updateHealthProfile, updatePharmacyCategories } = realTimeState.actions;
  // Export action creators
  
  // Export the reducer to be used in the store
  export default realTimeState.reducer;
  